import React, {useEffect, useRef, useState} from 'react';
import {Helmet} from "react-helmet";
import {Alert, Breadcrumb, BreadcrumbItem, Col, Row} from "reactstrap";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import CarerVoiceNotes from "./CarerVoiceNotes";
import {Link, withRouter} from 'react-router-dom';

function CallLogging(props) {

  const { getCarerVisits,
          getCarerVisitError,
          getCarerVisitSuccess,
          getCarerVisitLoader,
          updateVisit,
          updateVisitLoader,
          updateVisitError,
          updateVisitSuccess,
          location,
          history
  } = props;

  const [message, setMessage] = useState("");
  const [carerVisit, setCarerVisit] = useState(null);
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [isCancelled, setIsCancelled] = useState(false);
  const [notes, setNotes] = useState("");
  const [error, setError] = useState(false);
  const prevUpdateVisitSuccess = useRef();

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
    // Clear the other reason if "Other" is not selected
    if (event.target.value !== '14') {
      setOtherReason('');
    }
    handleSave("cancelled-reason", event.target.value)
  };

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
  };

  const handleCancellationToggle = (event) => {
    setIsCancelled(event.target.checked);
    if (!event.target.checked) {
      // Reset cancellation fields when toggling off
      setSelectedReason('');
      setOtherReason('');
      handleSave('is-cancelled', false);
    } else {
      handleSave('is-cancelled', true);
    }
  };

  const handleSave = (field, fieldValue) => {
    try {
      const payload = {
          action: "patch-visit-cancelled",
          attribute: field,
          attribute_value: fieldValue,
          event_id: carerVisit.id
        };
        // We update the visit here which in turn updates updateVisitSuccess
        updateVisit(payload);
      setMessage('Cancellation reason saved successfully.');
    } catch (error) {
      setMessage('Failed to save cancellation reason.');
    }
  };

  const handleSubmitNotes = (audioBlob, voiceNotes=true) => {
    if (voiceNotes) {
      const formData = new FormData();
      formData.append("file", audioBlob);
      formData.append("event_id", carerVisit.id);
      formData.append("action", "patch-audio-notes");
      updateVisit(formData);
    }
    if (!voiceNotes) {
      const payload = {
        action: "patch-text-notes",
        notes: notes,
        event_id: carerVisit.id
      };
      updateVisit(payload);
    }

  };


  useEffect(() => {
    // window.scrollTo(0, 0)
    const searchParams = new URLSearchParams(location.search);
    const qValue = searchParams.get("q");
    const vidValue = searchParams.get("vid");
    setMessage('')
    setError(false)
    setNotes('')
    if (qValue === "single" && vidValue) {
      const payload = {
        config: "single",
        vId: vidValue,
      };
      getCarerVisits(payload);
    }

  }, [])

  useEffect(() => {
    if (getCarerVisitSuccess) {
      setMessage('')
      setError(false)
      setCarerVisit(getCarerVisitSuccess[0]);
      setIsCancelled(getCarerVisitSuccess[0].service_user_cancelled);
      setSelectedReason(getCarerVisitSuccess[0].cancellation_reason);
      setOtherReason(getCarerVisitSuccess[0].cancellation_reason_other);
      setNotes(getCarerVisitSuccess[0].notes);
    }
  }, [getCarerVisitSuccess]);

  useEffect(() => {

    if (updateVisitSuccess) {
      const { action, notes: newNotes } = updateVisitSuccess;

      if (action === 'voice-notes' || action === 'text-notes') {
        console.log('Updating notes:', newNotes);
        setNotes(newNotes || ''); // Update local state
      }
    }
  }, [updateVisitSuccess]);

  useEffect(() => {
    if (updateVisitError) {
      const responseError = updateVisitError;
      if (responseError && responseError.status === 401) {
        setMessage("Session expired. Please login again.");
      } else if (responseError && responseError.response && responseError.response.detail) {
        setMessage(`Error: ${responseError.response.detail}`);
      } else {
        setMessage("An unexpected error occurred. Please try again.");
        setError(true);
      }
          document.body.scrollTop = 0
      window.scrollTo(0,0);
    }
  }, [updateVisitError]);

   // Function to process instructions
  const renderInstructions = (instructions) => {
    if (!instructions) return null;

    // Split the instructions by comma, trim whitespace, and filter out empty strings
    const instructionList = instructions
      .split(',')
      .map(instr => instr.trim())
      .filter(instr => instr.length > 0);

    // If there are no valid instructions, return null
    if (instructionList.length === 0) return null;

    return (
      <ul>
        {instructionList.map((instruction, index) => (
          <li key={index}>{instruction}</li>
        ))}
      </ul>
    );
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'In Progress':
        return 'line-yellow';
      case 'Done':
        return 'line-green';
      default:
        return 'header-line';
    }
  };

  return (
  <React.Fragment>
    <Helmet>
      <meta name="description" content="Electronic call monitoring" />
      <title>Excel Healthcare Services - Social and Domiciliary Care</title>
    </Helmet>
    <main>
      {/* Breadcrumb Navigation */}
      <div>
        <Breadcrumb>
          <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
          <BreadcrumbItem active>Visit Log</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </main>

    <div className='container'>
      <div>
        <div>
          <div style={{ paddingTop: "30px", paddingBottom: "150px" }}>
            {/* Display Visit Information */}
            {carerVisit ? (
              <div>
                <Typography style={{textAlign: "center", fontWeight: 800, fontSize: "1.5rem", color: '#3f51b5'}}>
                  {carerVisit.event_name}
                </Typography>
                <Typography style={{textAlign: "center", fontWeight: "bold"}}>
                  Visit with {carerVisit.service_user}
                </Typography>
                <Typography style={{textAlign: "center", fontWeight: "bold", color: "#3f51b5"}} variant="subtitle2">
                  Status - {carerVisit.status}
                </Typography>

                <br/>

                <Typography style={{textAlign: "center"}} variant="subtitle2">
                  Planned: {carerVisit.visit_start_time} - {carerVisit.visit_end_time}
                </Typography>
                <Typography style={{textAlign: "center"}} variant="subtitle2">
                  Actual:{" "}
                  {carerVisit.checked_in_time || carerVisit.checked_out_time
                    ? `${carerVisit.checked_in_time || "N/A"} - ${carerVisit.checked_out_time || "N/A"}`
                    : "N/A"}
                </Typography>

                <hr className={`${getStatusClass(carerVisit.status)}`}/>
                <div style={{paddingTop: "16px", paddingBottom: "16px", textAlign: "center"}}>
                  {message && (
                    <Alert color={error ? "danger" : "success"}>
                      {message}
                    </Alert>
                  )}
                </div>

                {/* Start Visit */}
                <Row className="mt-4">
                  <Col xs={3}>
                    <Typography>Start Visit:</Typography>
                  </Col>
                  <Col xs={9} className="d-flex justify-content-center">
                    <Button
                      onClick={() => history.push(`/ecm/call-logging/scan?q=single&vid=${carerVisit.id}&action=start-visit`)}
                      className="scanning-btns d-flex align-items-center"
                      disabled={carerVisit && carerVisit.is_started === true}
                      variant="contained" disableElevation
                      color="primary"
                      style={{textTransform: 'none'}}
                    >
                      <CameraAltIcon style={{marginRight: '8px'}}/>
                      Scan
                    </Button>

                  </Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* Care Plan */}
                <Row className="mt-4">
                  <Col xs={3}><Typography> Care Plan:</Typography></Col>
                  <Col xs={9} className="d-flex justify-content-center"></Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* Medication */}
                <Row className="mt-4">
                  <Col xs={3}><Typography> Medication:</Typography></Col>
                  <Col xs={9} className="d-flex justify-content-center"></Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* Notes */}
                <Row className="mt-4">
                  <Col xs={3}><Typography> Notes: </Typography></Col>
                  <Col xs={9} className="d-flex justify-content-center">
                    <CarerVoiceNotes
                      onSubmit={handleSubmitNotes}
                      textValue={notes}
                      onTextChange={setNotes}
                      updateVisitLoader={updateVisitLoader}
                    />
                  </Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* Instructions */}
                <Row className="mt-4">
                  <Col xs={3}><Typography>Instructions: </Typography></Col>
                  <Col xs={9}
                       className="d-flex justify-content-center">{renderInstructions(carerVisit.instructions)}</Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* End Visit */}
                <Row className="mt-4">
                  <Col xs={3}>
                    <Typography>End Visit:</Typography>
                  </Col>
                  <Col xs={9} className="d-flex justify-content-center">
                    <Button
                      style={{textTransform: 'none'}}
                      onClick={() => history.push(`/ecm/call-logging/scan?q=single&vid=${carerVisit.id}&action=end-visit`)}
                      className="scanning-btns d-flex align-items-center"
                      disabled={carerVisit && carerVisit.is_ended === true}
                      variant="contained" disableElevation
                      color="primary"
                    >
                      <CameraAltIcon style={{marginRight: '8px'}}/>
                      Scan
                    </Button>
                  </Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* New Cancellation Toggle */}
                <Row className="mt-4">
                  <Col xs={3}>
                    <Typography>Service User Cancelled:</Typography>
                  </Col>
                  <Col xs={9} className="d-flex justify-content-center">
                    <Switch
                      checked={isCancelled}
                      onChange={handleCancellationToggle}
                      color="primary"
                    />
                  </Col>
                </Row>
                <hr className="call-log-sect-line"/>

                {/* New Row for Cancellation Reason */}
                {isCancelled && (
                  <Row className="mt-4">
                    <Col xs={3}>
                      <Typography>Cancellation Reason:</Typography>
                    </Col>
                    <Col xs={9} className="justify-content-center" style={{textAlign: 'center'}}>
                      <div>
                        <Select
                          value={selectedReason}
                          onChange={handleReasonChange}
                          displayEmpty
                          variant="outlined"
                          disabled={updateVisitLoader}
                          style={{minWidth: '250px'}}
                        >
                          <MenuItem value="" disabled>Select a reason</MenuItem>
                          {carerVisit.cancellation_choices.map((choice) => (
                            <MenuItem key={choice.id} value={choice.id}>
                              {choice.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {selectedReason === '14' && (
                        <div>
                          <div>
                            <TextField
                              value={otherReason}
                              onChange={handleOtherReasonChange}
                              variant="outlined"
                              placeholder="Enter additional details for 'Other'"
                              className="mt-3"
                              style={{minWidth: '250px'}}
                              disabled={updateVisitLoader}
                            />
                          </div>
                          <div>
                            <Button
                              onClick={() => handleSave("cancelled-reason-other", otherReason)}
                              variant="contained"
                              color="primary"
                              className="scanning-btns  mt-3"
                              disableElevation
                              style={{textTransform: 'none'}}
                            >
                              Save
                            </Button>
                          </div>
                        </div>

                      )}
                    </Col>
                  </Row>
                )}

                {/* Incident and Accident */}
                <Row className="mt-4">
                  <Col xs={3}>
                    <Typography>Incident and Accident:</Typography>
                  </Col>
                  <Col xs={9} className="d-flex justify-content-center">
                    <Button
                      onClick={() => history.push(`/ecm/call-logging/report?q=single&vid=${carerVisit.id}&action=accident`)}
                      className="scanning-btns d-flex align-items-center"
                      variant="contained" disableElevation
                      color="primary"
                      style={{textTransform: 'none'}}
                    >
                      <ReportProblemIcon style={{marginRight: '8px'}}/>
                      Report
                    </Button>
                  </Col>
                </Row>
                <hr className="call-log-sect-line"/>

              </div>
            ) : getCarerVisitLoader ? (
              <p>Loading visit...</p>
            ) : (
              <p>No visit assigned.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
  );
}

export default withRouter(CallLogging);